import { Box, Typography } from '@mui/material';

import Button from 'shared/components/widgets/button';
import FieldBox from 'shared/components/widgets/field-box';
import FieldBoxProperty from 'shared/components/widgets/field-box-property';
import markAnyIdCard from '@assets/images/markAnyIdCard.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  staffSignupOkService,
  staffSignupService,
} from '@services/public/staff/jwt-issue.service';
import { ROUTES } from 'constants/routes';
import { useEffect, useState } from 'react';

const StaffRegister = () => {
  const location = useLocation();
  const [userInfo, setUserInfo] = useState<{
    name: string;
    email: string;
  }>();
  const state = location.state;
  const navigate = useNavigate();

  const fetchUserInfo = async () => {
    const userInfo = await staffSignupService({
      encUserPk: state?.encUserPk,
    });
    if (userInfo?.statusCode === 200) {
      setUserInfo(userInfo?.response?.result?.applyLoginInfo);
    } else {
      navigate(ROUTES.LOGIN.path);
    }
  };

  useEffect(() => {
    fetchUserInfo();
  }, []);

  const handleSignup = async () => {
    const resp = await staffSignupOkService({
      encUserPk: state?.encUserPk,
    });

    if (resp?.statusCode === 200) {
      navigate(ROUTES.LOGIN.path);
    }
  };

  return (
    <Box
      display="flex"
      width="100%"
      justifyContent="center"
      alignItems="center"
    >
      <Box display="flex" flexDirection="row" gap={30}>
        <Box width={300} height={300}>
          <img src={markAnyIdCard} width={300} height={300} alt="" />
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          minWidth="360px"
          maxWidth="360px"
        >
          <Typography
            variant="h6"
            color="var(--base-black)"
            textAlign="center"
            marginBottom="40px"
          >
            마크애니 직원 가입
          </Typography>
          <FieldBox>
            <FieldBoxProperty
              name="성명"
              type="text"
              value={userInfo?.name}
              keyStyle={{ minWidth: '140px', maxWidth: '140px' }}
            />
            <FieldBoxProperty
              name="이메일"
              type="text"
              value={userInfo?.email}
              keyStyle={{ minWidth: '140px', maxWidth: '140px' }}
            />
          </FieldBox>
          <Button
            onClick={handleSignup}
            variant="contained"
            sx={{ marginTop: '60px' }}
          >
            직원 가입하기
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default StaffRegister;
